export default __webpack_public_path__ + "static/media/LIC.e1e1dd54.png";